angular.
module("dx.webapp.invigilator").
constant("DX_INVIGILATOR_LOCATION_CONSTANTS", Object.freeze({
	START_EXAM_POPUP: "startExam",
	SCHEDULE_EXAM_POPUP: "scheduleExam",
	LIVE_VIEW: "live",
}));
